<!-- 商品列表页 -->
<template>
	<div>
		<van-sticky style="position: fixed;top: 0;left: 0; width: 100%;z-index: 999;">
		    <van-search
		        v-model="search"
		        show-action
				shape="round"
				background="#42C052"
		        :placeholder="group_search"
				action-text="返回"
		        @search="onSearch"
		        @cancel="onCancel"
				@focus="onFocus"
		    />
		</van-sticky>
		<div style="margin:70px 0 10px 0;" v-if="total">
			共找到{{total}}个商品
		</div>
		<div style="margin:70px 0 10px 0;" v-if="noGoods && !total">
			未找到相关商品
		</div>
		<div v-if="item_list" style="margin-bottom: 30px;">	
			<van-list
			  v-model="loading"
			  :finished="finished"
			  :finished-text="finishedText"
			  @load="onLoad"
			  :immediate-check="false"
			>
				<!-- 每个商品列表 -->
				<van-row v-for="(product,index) in item_list" :key="index" type="flex" class="card-box" @click="goProductInfo(product,activityInfo)">
					<!-- 商品图片 -->
				  <van-col span="6" style="padding: 2px;box-sizing: border-box;position: relative;padding-left: 10px;">
					  <van-image v-if="product.flag_type"  fit="cover" :src="goodsTags[product.flag_type]" style="width: 30px; position: absolute; top: 2px;left: 8px;z-index: 2;"></van-image>
					  <van-image  fit="cover" :src="product.image[0]" lazy-load >
					  	<template v-slot:loading>
					  		<van-loading type="spinner" size="20" />
					  	</template>
					  </van-image>
				  </van-col>
				  <van-col span="18" style="padding: 5px 8px;">
					  <van-row style="display: flex; flex-direction: column; justify-content: space-between;">
					    <van-col style="width: 100%;" class="product-name van-ellipsis">{{product.name}}</van-col><!-- 商品名称 -->
					    <van-col style="width: 100%;" class="product-size"><span v-if="product.size">{{product.size}}</span><span v-if="product.unit_name">/{{product.unit_name}}</span> </van-col><!-- 商品规格 -->
						<van-col style="width: 100%;" v-if="product.limit_num" class="product-limit">每人限购{{product.limit_num}}{{product.unit_name}}</van-col><!-- 商品限购 -->
						<van-col style="width: 100%;" class="product-size" v-if="product.order_num">累计销量{{product.order_num}}{{product.unit_name}}</van-col><!-- 商品名称 -->
						<!-- 商品规格 -->
					    <van-col style="width: 100%;">
							<van-row type="flex" style="justify-content: center;align-items: center;">
								<van-col  class="product-price"><span>￥</span>{{(product.vip_price*1).toFixed(2)}}</van-col>						
								<van-col  style="flex:1;text-align: right;padding-right: 10px;">								
										<van-button color="#00C719" round disabled style="height: 30px;" v-if="product.stock<=0 && product.is_no_stock==2">
										  已售罄
										</van-button>
										<div v-else>
											<van-icon name="cart" size="36" color="#00C719" :badge="product.groupCartNum ? product.groupCartNum : ''" @click.stop="getCart(product)" />											
										</div>														
								</van-col>
							</van-row>
							<van-col style="width: 100%;" class="product-stock" v-if="product.is_no_stock == 2 && (product.stock-product.min_stock <= 0 && product.stock!== 0)">仅剩{{product.stock}}件</van-col>
						</van-col>
					  </van-row>
				  </van-col>
				</van-row>
			</van-list>
		</div>
		<!-- <van-divider>到底了</van-divider> -->
		<transition name="van-slide-up">		
		  <div style="width: 32%; position: fixed;right: 16%;bottom: 20px; z-index: 999;" v-if="cartShow&&1&&cartTotalNum" >
		  	<van-button color="linear-gradient(to right, #ff6034, #ee0a24)" size="large" round  @click="goCart">
		  	<!-- <van-icon name="cart-o" :badge="cartTotalNum" size="30" /><span>￥{{cartTotalPrice}}</span> -->
		  	</van-button>
		  </div>
		</transition>
	</div>		
</template>

<script>
import {mapState, mapActions} from 'vuex'	
export default {
  name: 'searchList',
  
  data(){
	  return{
		search:'',
		item_list:[],
		active :0,//商品标签激活
		show:false,//弹出框开关
		activityInfo:{},//根据Id获取的活动详情
		cartShow:false,
		goodsTags:{
			'爆品':require('../../assets/hot_tag.png'),
			'热销':require('../../assets/sale_tag.png'),
			'新品':require('../../assets/new_tag.png'),
		},
		page:1,
		last_page:"",
		loading: false,
		finished: false,
		finishedText:'',
		total:'',
		noGoods:false,
		
	  }
  },
  methods:{ 
	  ...mapActions(['addCartAsync','modifyCartAsync','delCartItemAsync','getItemNum']),

	  //进入商品详情页
	  goProductInfo(currentInfo,activityInfo){
		 this.$router.push({
			path:'productInfo',
			query:{
				id:currentInfo.id
				
			}
		})  
	  },
	  // 加购物车
	  getCart(params){	 
		this.$store.dispatch('addCartAsync',params)
	  },  
	  //提交购物车订单支付
	  onSubmit(){
	  	this.$router.push('/orderSubmit')
	  },						
	  //当购物车中商品数量变化时			
	  carNumChange(product){
	  	if(product.goods_num==0){
	  	  this.delCartItemAsync(product)
	  	} 
		else {
	  	  this.modifyCartAsync(product)
	  	}
	  },	  
	  //返回上级菜单
	backIndex() {
		  this.$router.push('/')
	    },
	goIndex(){
		 this.$router.push('/')
	},
	 //打开遮罩层
	 openCart(){
		 this.show=true		
	 },
	 //搜索商品
	 getSearchItem(){
		 const toast=this.$toast.loading({
		   message: '',
		   forbidClick: true,
		   loadingType: 'spinner',
		 });
		 this.loading = false
		 this.finished= false
		 this.finishedText=''		
		this.request.postURL('/api/activity/getSearchItem',{
		 	search:this.search,
			page:this.page,
			pageSize:10
		 }).then((res)=>{
			
			// this.item_list=res.data.data.data		
			
			
			//判断数据条数是否为0
			if(res.data.data.data.length === 0){
				this.finished=true //停止加载
				this.finishedText='未找到相关商品'
				this.noGoods =  true
			}
			//若数据条目不为0
			
			this.item_list.push(...res.data.data.data)//将数据放在列表中
			this.total=res.data.data.total //给数据条数赋值
			this.last_page=res.data.data.last_page//最后一页
			this.loading=false //加载状态结束
			//如果list长度大于等于总数据条数
			if(this.item_list.length>=this.total){
				this.finished=true  //结束加载状态
				this.finishedText=''
			}
			
			if(this.token){
				this.setGroupGoodsBadage()
				this.$store.dispatch('cartGetAsync')
				if(this.cartTotalNum){
					this.cartShow=true
				}
			}
			toast.clear()	
			
		 }).catch((err)=> {
		    toast.clear()
		   });
	 },
	 //设置团购商品角标
	 setGroupGoodsBadage(){
		 for(var i=0;i<this.item_list.length;i++){
			 if(this.groupList.hasOwnProperty(this.item_list[i].activity_id) && this.groupList[this.item_list[i].activity_id].hasOwnProperty(this.item_list[i].item_id)){
				 this.item_list[i].groupCartNum = this.groupList[this.item_list[i].activity_id][this.item_list[i].item_id]		 
			 }			
		 }
	 },
	 goCart(){
		 this.$router.push('/cart')
	 },
	 onSearch(){
		 this.getSearchItem()
	 },
	 onFocus(){
		 this.item_list=[];
		 this.page = 1;
		 this.total = 0;
		 this.noGoods = false
	 },
	 onCancel(){
		 this.$router.go(-1)
	 },
	 onLoad(){
		 if(this.page<=this.last_page){
			this.page++
			this.getSearchItem()
		 }
		 else{
			 this.finished=true
			 this.finishedText=''
		 }
	 					 
	 },
		
  },
  computed:{
	   ...mapState(['cartList','token','groupList','group_search','cartTotalNum']),
	   // ...mapGetters(['cartTotalPrice']),
  },
  mounted() {
  	 
  },
  beforeDestroy() {
	    this.cartShow=false 
		 this.item_list=[]
  },
  beforeRouteLeave(to,from,next) {
  	if(to.path == '/productInfo'){
		 from.meta.keepAlive = true
	}
	// console.log(from)
	next()
  },
 
  created() {
	 
  },
  watch:{
	  cartTotalNum(){
		  if(this.cartTotalNum==0){
			  this.cartShow=false
		  }
		  else{
			  this.cartShow=true
		  }
		  
	  },
	  groupList:{
		  deep:true,
		  handler:function(to,from){
			this.setGroupGoodsBadage();	
			this.$forceUpdate()		
		  }
	  }
  },
}
</script>

<style>
	.card-box{
		justify-content: center;
		align-items: center;
		border-bottom: 1px solid #eee;
		/* padding: 4px 0; */
	}
	.product-name{
		text-align: left;
		font-weight: 550;
	}
	.product-size{
		text-align: left;
		color: #888888;
		font-size: 14px;
	}
	.product-limit{
		text-align: left;
		color: red;
		font-size: 14px;
	}
	.product-price{
		flex: 1;
		text-align: left;
		font-size: 18px;
		color: red;
		font-weight: 550;
	}
	.product-stock{
		text-align:left;
		font-size: 14px;
		color:red;	
	}
	.product-price span{
		font-size: 14px;
		font-weight: 0;
	}
	.goods-card{
		width: 100%;
		text-align: left;
	}
	.good-card{
		background-color: #ffffff;
		padding: 0 20px;
	}
	.cart-zone-title{
		font-size: 16px;
		padding: 20px 0 0 20px;
	}
	.delete-button {
	    height: 100%;
	  }
	.back-index{
		width: 40px;
		height:40px;
		vertical-align: middle;
		background-color: rgba(255,255,255,.3);
		border-radius: 40px;
		position: absolute; 
		top: 3px; 
		left: 10px; 
		z-index:99;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.activity-text{
		padding:5px 20px;
		text-align: left;
	}
	.activity-text p{
		margin:0 0 8px 0;
	}
	.activity-text p img{
		
		
	}
	.activity-text1  p {
		margin: 0;
		padding: 0;
	}
	.activity-text1  p img{
		width: 100%;
	}
	.activity-text img{
		width: 100%;
	}
	.van-tab--active{
		font-weight: 800;
	}
	.colon {
	  display: inline-block;
	  margin: 0 4px;
	  color: #fff;
	  font-size: 16px;
	}
	.block {
	  display: inline-block;
	  width: 22px;
	  color: #fff;
	  font-size: 16px;
	  text-align: center;
	  background-color: #ee0a24;
	}
	.van-search__action{
		color: #fff;
	}
</style>
<style >
	
</style>
